import React from 'react';
import { Layout, ConfigProvider } from 'antd';
import { getTheme, useTheme } from '../../resources/theme';
import { useSideBarCollapse } from './hook/useSideBarCollapse';
import HeaderLayout from './layout/headerLayout';
import SiderLayout from './layout/siderLayout';
import ContentLayout from './layout/contentLayout';
import FooterLayout from './layout/footerLayout';
import { BreadcrumbRoutes } from '../breadcrumb';

const LayoutPage = () => {
  const { sidebarMode, globalTheme } = useTheme();

  return (
    <ConfigProvider theme={globalTheme}>
      <Layout
        className="site-layout"
        style={{
          minHeight: '100vh',
        }}
      >
        <HeaderLayout
          getTheme={getTheme}
          sidebarMode={sidebarMode}
        />
        {/* <BreadcrumbRoutes /> */}
        <ContentLayout getTheme={getTheme} sidebarMode={sidebarMode} />
        <FooterLayout />
      </Layout>
    </ConfigProvider>
  );
};

export default LayoutPage;
